import type { TDadataFullAddressSelectOption } from 'shared/types/TDaData';

export const transformationAddressList = (data: TDadataFullAddressSelectOption[]) =>
  data.map(({ value }) => ({
    label: value,
    value,
  }));
